import { useState, useCallback } from "react";
import { db } from "../services/firebase";
import { ref, set, push } from "firebase/database";

export default function useDeletePack() {

    const [deletingPack, setDeletingPack] = useState(false);
    const [deletingPackError, setDeletingPackError] = useState(null);

    const deletePack = useCallback(async (domainId, packId) => {

        try {
            setDeletingPack(true);
            setDeletingPackError(null);

            let packRef = ref(db, `Packs/${domainId}/${packId}`);

            await set(packRef, null);

            return true;

        } catch (err) {

            setDeletingPackError("Failed to delete pack");
            return false;

        } finally {
            setDeletingPack(false);
        }
    }, []);

    return { deletePack, deletingPack, deletingPackError };
}
